import { AxiosRequestConfig } from 'axios'
import { v7 as uuidv7 } from 'uuid'

import { generateAwsTraceId } from '../utils/commonUtils'

const EXCLUDE_TRACING_HEADERS_URL_REGEX = /^https:\/\/vendorapi.*\.lyrahealth\.com|^https:\/\/api\.vimeo\.com/

export const API_REQUEST_HEADERS = {
  // Context UUID sent to our APIs
  X_CONTEXT_UUID: 'X-Context-UUID',
  // LD Flags
  X_FEATURES: 'X-Features',
  // Whether the health kit is enabled
  X_IS_HEALTH_KIT_ENABLED: 'X-Lyra-is-health-kit-enabled',
  // Needed for LWAPI controller to handle proxying correctly
  X_IS_MOBILE_APP: 'X-Is-Mobile-App',
  // The user's display language
  X_LYRA_LOCALE: 'X-Lyra-Locale',
  // AWS specific header
  X_AMZN_TRACE_ID: 'X-Amzn-Trace-Id',
  // The Essentials theme to load (e.g. "aurora_light", "wfmh_dark")
  X_LYRA_THEME: 'x-lyra-theme',
  // Indicates Freshpaint SDK should be enabled for Goodness CMS iframes (passed as a URL query param)
  X_FRESHPAINT_ENABLED: 'x-freshpaint-enabled',
}

export function setTracingRequestHeaders(config: AxiosRequestConfig, sessionUuid?: string | null) {
  if (config.url && !EXCLUDE_TRACING_HEADERS_URL_REGEX.test(config.url) && config.headers) {
    // UUIDv7 is lexicographically sortable and has a timestamp component
    const contextUuid = uuidv7()
    config.headers[API_REQUEST_HEADERS.X_AMZN_TRACE_ID] = generateAwsTraceId(contextUuid, sessionUuid)
    config.headers[API_REQUEST_HEADERS.X_CONTEXT_UUID] = contextUuid
  }
}
